module.exports = __webpack_public_path__ + "fonts/montserrat-light-webfont.70df5da69722ec23336c227bf131d5ab.ttf?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/font/montserrat-light-webfont.ttf
// module id = 713
// module chunks = 9